import React from 'react';
import Typography from '~/components/base/Typography';
import BackgroundWrapper from '~/components/modules/BackgroundWrapper';
import './direct-access-blocked.scss';

/**
 * Shown instead of the app when Welfare is opened directly in a browser.
 *
 * Deliberately a dead end: no login form, no retry, nothing to act on here. The
 * only way in is the host application, so the message points at that rather
 * than offering a control that cannot work.
 *
 * Says nothing about why access is restricted or what lives behind it -- this
 * page is served to anyone who types the URL.
 *
 * @returns {JSX.Element} the blocked notice
 */
export default function DirectAccessBlocked(): JSX.Element {
    return (
        <BackgroundWrapper>
            <div className='direct-access-blocked'>
                <Typography size={18} weight='semi-bold' color='light'
                    className='direct-access-blocked-title'>
                    Open Welfare from the app
                </Typography>
                <Typography size={14} color='light'
                    className='direct-access-blocked-desc'>
                    Welfare is no longer available directly in a browser. Please sign in to the app on your phone, or to the web app, and open Welfare from there.
                </Typography>
            </div>
        </BackgroundWrapper>
    );
}
